import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './UserOnboardingPage.css';

const SubscriptionConfirmation = ({ setOnboardingData, onboardingData }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { selectedOption } = location.state || {};

  if (!selectedOption) {
    navigate('/subs');
    return null;
  }

  const handleBack = () => {
    navigate('/subs');
  };

  const handleConfirm = () => {
    navigate('/payment', { state: { selectedPlan: selectedOption, onboarding: true  } });
  };

  return (
    <div className="subscription-confirmation">
      <h1>Confirm Your Subscription</h1>
      <p className='text'>Ensure that you are happy with your chosen subscription and confirm below to proceed to payment.</p>
      
      <div className="selected-plan">
        <h2>{selectedOption.title}</h2>
        <div className="desc">
          {selectedOption.desc.map((desc, index) => (
            <p key={index}>{desc}</p>
          ))}
        </div>
        <div className='plan'>
          <p className='pkg'>{selectedOption.pkg}</p>
          <p className='price'>{selectedOption.price}</p>
        </div>
        
        <button className="confirmed-button" onClick={handleConfirm}>Confirmed</button>
        <p className='detail'>{selectedOption.detail.join(' ')}</p>
      </div>

      <div className="actions">
        <button className="back-button" onClick={handleBack}>Go Back</button>
        <button className="confirm-button" onClick={handleConfirm}>Confirm</button>
      </div>
    </div>
  );
};

export default SubscriptionConfirmation;
